export const LogoImage = "./assets/images/loader.gif";
